module.exports = __webpack_public_path__ + "static/media/aspen2.1f300d20.PNG";